module.exports = __webpack_public_path__ + "static/media/MEDIUM_ENERGY.27e0f1c1.svg";